import { mountKey } from '@/utils/courses';
import { CoursesModelsType } from '@/utils/trees/TreeCourses';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export type CoursePathSegment = {
  type: CoursesModelsType;
  id: number | string;
  key: string;
};

type useCoursesPathReturn = {
  segments: CoursePathSegment[];
  currentSegment?: CoursePathSegment;
};
export const useCourseSegments = (): useCoursesPathReturn => {
  const { pathname } = useLocation();

  const segments = useMemo(() => {
    return convertPathToSegments(pathname);
  }, [pathname]);

  const currentSegment = segments.at(-1);

  return {
    segments,
    currentSegment,
  };
};

const PATH_MAPPING: Record<string, CoursesModelsType> = {
  'course-lines': 'courseLine',
  module: 'module',
  'ped-content': 'course',
  unit: 'unit',
  lesson: 'lesson',
};

export const convertPathToSegments = (path: string) => {
  const result: CoursePathSegment[] = [];
  const segments = path.split('/');

  for (let i = 0; i < segments.length; i++) {
    const segment = decodeURIComponent(segments[i]);
    const rawNext = decodeURIComponent(segments[i + 1] ?? '');

    if (segment in PATH_MAPPING && rawNext) {
      const type = PATH_MAPPING[segment];
      const id = type === 'course' ? rawNext : Number(rawNext);

      if (type !== 'course' && isNaN(id as number)) continue;

      const key = mountKey({ type, id });
      result.push({ type, id, key });
    }
  }
  return result;
};
